export var TextActionAppearance;
(function (TextActionAppearance) {
    TextActionAppearance["filled"] = "filled";
    TextActionAppearance["outline"] = "outline";
})(TextActionAppearance || (TextActionAppearance = {}));
export var TextActionButtonPosition;
(function (TextActionButtonPosition) {
    TextActionButtonPosition["before"] = "before";
    TextActionButtonPosition["after"] = "after";
})(TextActionButtonPosition || (TextActionButtonPosition = {}));
